import React, { memo } from 'react'
import SetupGuideCard from './SetupGuideCard'
import { useSetupGuideInfoQuery } from './graphql/SetupGuideInfo'
import { isUsersMotorCarriersSetupComplete } from './utils'

export interface ISetupGuideSectionProps {}

const SetupGuideSection = memo<ISetupGuideSectionProps>(() => {
  const { data } = useSetupGuideInfoQuery({ fetchPolicy: 'cache-and-network' })
  const { motorCarriersForUser = [] } = data || {}
  const showSetupGuide = !isUsersMotorCarriersSetupComplete(motorCarriersForUser)

  return showSetupGuide ? <SetupGuideCard motorCarriersForUser={motorCarriersForUser} /> : null
})

export default SetupGuideSection
